import { endpoint, env, getAuthToken, handleUnauthorized, toResponseError, } from '@eruvaka/web-pondlogs-base';
// ── Helpers ──────────────────────────────────────────────────────────────────
const parseJson = async (res) => {
    try {
        return await res.json();
    }
    catch {
        return {};
    }
};
const apiRequest = async (method, path, body) => {
    const token = getAuthToken();
    const response = await fetch(endpoint(env.apiBaseUrl, path), {
        method,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    if (!response.ok) {
        const text = await response.text();
        if (response.status === 401) {
            handleUnauthorized();
            throw toResponseError(response.status, text);
        }
        throw toResponseError(response.status, text);
    }
    return parseJson(response);
};
const isRecord = (v) => typeof v === 'object' && v !== null;
const toDeviceArray = (value) => {
    if (!Array.isArray(value))
        return [];
    return value.filter((item) => isRecord(item) && typeof item._id === 'string');
};
// ── Public API ───────────────────────────────────────────────────────────────
/**
 * Fetch devices belonging to the authenticated user.
 * @param types  Device types to include (default: all three)
 * @param unAssignedOnly  Return only devices not yet assigned to a pond (default: true)
 */
export const fetchUserDevices = async (types = ['POND_MOTHER', 'SHRIMP_TALK', 'POND_GUARD'], unAssignedOnly = true) => {
    const body = Object.fromEntries(types.map((t) => [t, { title: 1, code: 1 }]));
    const payload = await apiRequest('POST', `/api/v3/users/devices?un_assigned_only=${unAssignedOnly}`, body);
    // Response shape: { success, devices_data: { pond_mothers, pond_guards, shrimp_talks } }
    const data = isRecord(payload) && isRecord(payload.devices_data) ? payload.devices_data : {};
    return {
        pond_mothers: toDeviceArray(data.pond_mothers),
        pond_guards: toDeviceArray(data.pond_guards),
        shrimp_talks: toDeviceArray(data.shrimp_talks),
    };
};
/** Assign pond mothers to their respective ponds. */
export const assignPondMothers = async (assignments) => {
    await apiRequest('POST', '/api/v3/ponds/pond-mothers', assignments);
};
/** Assign pond guards to their respective ponds. */
export const assignPondGuards = async (assignments) => {
    await apiRequest('POST', '/api/v3/ponds/pond-guards', assignments);
};
/** Assign shrimp talks to their respective ponds. */
export const assignShrimpTalks = async (assignments) => {
    await apiRequest('POST', '/api/v3/ponds/shrimp-talks', assignments);
};
